/* v67: scroll pop-ins, calm version. One-shot, quick, safe with AJAX sections, fast scrolling and reduced motion.
   Product cards (product-card, routine cards, "best for" tiles) are NOT animated at all: lifting and scaling every card as it came into view looked like shaking while scrolling.
   Only headings, the sale steps, the "why" cards and the round icons ease in. Nothing is hidden by CSS while waiting for this script, so if it never runs the page simply shows normally. */
(function () {
  'use strict';
  var preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  var STILL = '.product-card, .sb-rcard, .sb-rstep, .sbc-tile';
  var STEP = '.sb-ladder__step, .sb-why__card';
  var ICON = '.sb-trust__ico';
  var selectors = STEP + ', ' + ICON + ', .sb-head, .sb-pagehead h1, .product-info__title, .sb-reveal, .da-reveal';
  var skip = '[aria-hidden="true"], [hidden], .product-form, .cart-drawer, [data-cart-drawer]';
  var seen = new WeakSet();
  var active = new Set();
  var observer;
  var main;
  var mutation;

  function delayFor(el) {
    if (!el.matches(STEP) && !el.closest('.sb-trust__item')) return 0;
    var item = el.closest('.sb-trust__item') || el;
    var parent = item.parentElement;
    var index = parent ? Array.prototype.indexOf.call(parent.children, item) : 0;
    return Math.min(3, Math.max(0, index)) * 80;
  }

  function play(el, rect) {
    if (preference.matches || !el.animate || !el.isConnected) return;
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
    var keys;
    var timing;
    if (el.matches(ICON)) {
      keys = [
        { opacity: 0, scale: '.4' },
        { opacity: 1, scale: '1.15', offset: .6 },
        { opacity: 1, scale: '.96', offset: .8 },
        { opacity: 1, scale: '1' }
      ];
      timing = { duration: 460, easing: 'ease-out' };
    } else if (el.matches(STEP)) {
      keys = [
        { opacity: 0, translate: '0 14px', scale: '.94' },
        { opacity: 1, translate: '0 0', scale: '1' }
      ];
      timing = { duration: 380, easing: 'cubic-bezier(.2,.75,.3,1)' };
    } else {
      keys = [
        { opacity: 0, translate: '0 16px' },
        { opacity: 1, translate: '0 0' }
      ];
      timing = { duration: 380, easing: 'cubic-bezier(.2,.75,.3,1)' };
    }
    timing.delay = delayFor(el);
    timing.fill = 'backwards';
    var animation = el.animate(keys, timing);
    active.add(animation);
    animation.onfinish = animation.oncancel = function () { active.delete(animation); };
  }

  function inside(el, r) {
    if (!r.width || !r.height) return false;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    return !(r.top >= vh * .9 || r.bottom <= 0 || r.left >= vw || r.right <= 0);
  }

  function scan(root) {
    var nodes = [];
    if (root.matches && root.matches(selectors)) nodes.push(root);
    if (root.querySelectorAll) nodes = nodes.concat(Array.from(root.querySelectorAll(selectors)));
    var todo = [];
    nodes.forEach(function (el) {
      if (seen.has(el)) return;
      seen.add(el);
      // A whole block animates once; nested copy must not animate again. Product cards never animate.
      if (el.parentElement && el.parentElement.closest(selectors)) return;
      if (el.matches(STILL) || el.closest(STILL)) return;
      if (el.closest(skip)) return;
      todo.push(el);
    });
    if (preference.matches || !todo.length) return;
    var rects = todo.map(function (el) { return el.getBoundingClientRect(); });
    todo.forEach(function (el, i) {
      // Already on screen: ease in right away (no flash). Otherwise wait until it scrolls into view.
      if (inside(el, rects[i])) play(el, rects[i]);
      else if (observer) observer.observe(el);
    });
  }

  function start() {
    main = document.getElementById('MainContent');
    if (!main || !('IntersectionObserver' in window)) return;
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        play(entry.target, entry.boundingClientRect);
      });
    }, { threshold: .12, rootMargin: '0px 0px -6% 0px' });
    scan(main);
    mutation = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) { if (node.nodeType === 1) scan(node); });
      });
    });
    mutation.observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) {
      if (event.target instanceof Element && main.contains(event.target)) scan(event.target);
    });
    var change = function () {
      active.forEach(function (animation) { animation.cancel(); });
      if (observer) observer.disconnect();
      if (!preference.matches) { seen = new WeakSet(); scan(main); }
    };
    if (preference.addEventListener) preference.addEventListener('change', change);
    else if (preference.addListener) preference.addListener(change);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();